import {selectOverlay, setOverlay} from "../../redux/features/overlaySlice";
import {useSelector} from "react-redux";

export default function Overlay() {

    const show = useSelector(selectOverlay)

    return show ? <div style={{position: 'fixed', backgroundColor: 'transparent', height: '100vh', width: '100vw', zIndex: 1}} onClick={() => setOverlay(false)}/> : <></>
}